var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Parses a time of format hours-minutes, optionally containing seconds and even centiseconds information.
 * @param value The value to parse
 * @category Value parsers
 */
export var parseExactTime = function (value) {
    // Note: Gedcom 5.5.5 says *no* leading zeros are allowed on hours. For compatibility purposes we *do* accept them anyway
    var rTime = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9])(?:\.([0-9]{2}))?)?$/;
    if (!value) {
        return null;
    }
    var groups = rTime.exec(value);
    if (!groups) {
        return null;
    }
    var hours = parseInt(groups[1]);
    var minutes = parseInt(groups[2]);
    var hoursMinutes = {
        hours: hours,
        minutes: minutes,
    };
    if (groups[3] !== undefined) {
        var seconds = parseInt(groups[3]);
        var hoursMinutesSeconds = __assign(__assign({}, hoursMinutes), { seconds: seconds });
        if (groups[4] !== undefined) {
            var centiseconds = parseInt(groups[4]);
            return __assign(__assign({}, hoursMinutesSeconds), { centiseconds: centiseconds });
        }
        else {
            return hoursMinutesSeconds;
        }
    }
    else {
        return hoursMinutes;
    }
};
//# sourceMappingURL=exacttime.js.map